import Http from '../http';

const prefix = '/website-multiple-action';

export const get = id => {
  return Http.authApiV2().get(`${prefix}?website_id=${id}`);
};

export const getOne = id => {
  return Http.authApiV2().get(`${prefix}/${id}`);
};

export const create = params => Http.authApiV2().post(`${prefix}`, params);

export const update = header => {
  return Http.authApiV2().put(`${prefix}/${header.action_id}`, header);
};

export const destroy = id => {
  return Http.authApiV2().delete(`${prefix}/${id.action_id}`,);
};


// WEBPACK FOOTER //
// ./src/js/services/editor/multiactions.js